module.exports = __webpack_public_path__ + "static/img/point.76a69db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s33/pop/point.png
// module id = hRBh
// module chunks = 2